var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mission-name",attrs:{"refs":"missionName"}},[_c('span',[_vm._v("Misja:")]),_c('p',[_vm._t("mission"),_c('span',{staticClass:"gamename"},[_vm._t("title")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }